/* Code for search placeholder changeable text*/
// Array of placeholder texts
const placeholders = [
    "Tillers",
    "Cutters",
    "Harrows",
];

let index = 0; // To track the current placeholder text
let typing = true; // To track if we're typing or deleting
let currentText = "Search For "; // The static text initially
let typingIndex = 0; // To track the character index being typed/deleted
let speed = 150; // Speed of typing and deleting in milliseconds

function changePlaceholder() {
    const input = document.querySelector(".om-custom-placeholder");

    // Get the current dynamic word from the array
    let dynamicText = placeholders[index];

    // Typing phase - add one character at a time
    if (typing) {
        currentText = "Search For " + dynamicText.slice(0, typingIndex++);
        input.setAttribute("placeholder", currentText);

        if (typingIndex > dynamicText.length) {
            setTimeout(() => {
                typing = false; // Switch to deleting phase after a short delay
            }, 500); // 1-second pause before deleting
        }
    }
    // Deleting phase - remove one character at a time
    else {
        currentText = "Search For " + dynamicText.slice(0, typingIndex--);
        input.setAttribute("placeholder", currentText);

        if (typingIndex <= 0) {
            typing = true; // Switch back to typing phase
            index = (index + 1) % placeholders.length; // Move to next word
        }
    }
}



setInterval(changePlaceholder, speed);

document.addEventListener("DOMContentLoaded", function () {
    function checkTopBadge() {
        let topBadge = document.querySelector(".topbadge");
        if (topBadge) {
            let badgeText = topBadge.textContent.trim();
            console.log("Badge Found:", topBadge, "Text:", badgeText);
            
            if (badgeText === "") {
                console.log("Badge is empty, hiding it.");
                topBadge.classList.add("hidden-badge"); // Hide badge
            } else {
                console.log("Badge has content, showing it.");
                topBadge.classList.remove("hidden-badge"); // Show badge
            }
        }
    }

    // Check once after a delay (in case it's added dynamically)
    setTimeout(checkTopBadge, 1000);

    // Observe the DOM for changes (for dynamically added badges)
    const observer = new MutationObserver(() => {
        checkTopBadge();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});





